import { Api } from '@/infrastructure';
import { useMutation, UseMutationResult } from 'react-query';
import { FileInfo } from '@/components/shared/file-upload/types';

export interface S3UploadParams {
  upload_url: string;
  file_key: string;
}

export interface S3UploadParamsResponse {
  presigned_requests: S3UploadParams[];
}

export const useGetS3UploadParamsMutation = (token: string): UseMutationResult<S3UploadParamsResponse, Error, {
  files: FileInfo[];
}> => {
  return useMutation(
    async ({ files }) => {
      const response = await Api.post({
        path: `direct_schedule_adjustments/${token}/s3_direct_upload_parameters`,
        data: { files }
      });
      return response.data;
    }
  );
};

export const useS3UploadMutation = (): UseMutationResult<string, Error, {
  file: File;
  uploadParams: S3UploadParams;
  contentMd5?: string;
}> => {
  return useMutation(
    async ({ file, uploadParams, contentMd5 }) => {
      const headers: Record<string, string> = {};
      
      if (file.type) {
        headers['Content-Type'] = file.type;
      }
      
      if (contentMd5) {
        headers['Content-MD5'] = contentMd5;
      }

      try {
        await Api.putForS3({
          url: uploadParams.upload_url,
          data: file,
          headers,
        });
        
        // 成功時はfile_keyを返す
        return uploadParams.file_key;
      } catch (error) {
        if (error instanceof Error) {
          throw new Error(`アップロードに失敗しました`);
        }
        throw error;
      }
    }
  );
};